import svgBase64 from "./svgBase64";

function encodeSvgWithColor(svg, color = "#000000") {
  if (!svg) return;
  return svgBase64(svg.split("#000000").join(color));
}

export default encodeSvgWithColor;
